import $http from '../../../axios-instance';
import Swal from 'sweetalert2';
import { controlErrorsCallback } from '../../../helpers/forms';

/**
 * Cargar todos campos personalizados.
 *
 * @param {*} { commit }: store del módulo.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function getAll({ commit }, status) {
    commit('dashboard/load', true, { root: true });

    if (!status) status = 1;

    await $http.get(`nu-gres/custom-fields?status=${status}`)
        .then(({ data: response }) => commit('setCustomFields', response.data))
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Campos personalizados',
                text: 'Falla al tratar de cargar los campos personalizados.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Crear campos personalizados.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} payload: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function store({ commit, dispatch }, payload) {
    commit('dashboard/load', true, { root: true });

    await $http.post('nu-gres/custom-fields', payload)
        .then(({ data: response }) => {

            dispatch('getAll', 'ALL')
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Campos personalizados',
                text: response.message,
                showConfirmButton: true,
            })

            commit('resetCustomField');
            commit('setAction');

        })
        .catch(errors => {

            // Errores de validaciones
            if (controlErrorsCallback(errors)) return false;

            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Campos personalizados',
                text: 'Falla al tratar de crear el campo personalizado.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Editar campos personalizados.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} payload: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function update({ commit, dispatch }, payload) {
    commit('dashboard/load', true, { root: true });

    await $http.put(`nu-gres/custom-fields/${payload.id}`, payload)
        .then(({ data: response }) => {

            dispatch('getAll', 'ALL')
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Campos personalizados',
                text: response.message,
                showConfirmButton: true,
            })

            commit('resetCustomField');
            commit('setAction');

        })
        .catch(errors => {

            // Errores de validaciones
            if (controlErrorsCallback(errors)) return false;

            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Campos personalizados',
                text: 'Falla al tratar de actualizar el campo personalizado.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}